"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Label_1 = tslib_1.__importDefault(require("./Label"));
/**
 * @deprecated use explicit classes instead
 */
class HTML extends Label_1.default {
}
exports.default = HTML;
//# sourceMappingURL=HTML.js.map